import React from "react";
import { classNames } from "../../lib/utils";

/** Tiny coloured chip used across every report tab for headline stats. */
export function StatChip({ label, value, tone = "sky", ...rest }) {
  const tones = {
    sky: "bg-sky-50 text-sky-700 border-sky-200",
    purple: "bg-purple-50 text-purple-700 border-purple-200",
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    slate: "bg-slate-50 text-slate-700 border-slate-200",
  };
  return (
    <div className={classNames("rounded-lg border px-3 py-2", tones[tone])} {...rest}>
      <p className="text-[11.5px] uppercase tracking-wider font-bold opacity-70">{label}</p>
      <p className="text-xl font-heading font-bold tabular-nums">{value}</p>
    </div>
  );
}

/** Plain-CSV download helper. Skips the download when there are no rows. */
export function downloadCSV(filename, rows) {
  if (!rows.length) return;
  const headers = Object.keys(rows[0]);
  const escape = (v) => {
    if (v == null) return "";
    const s = String(v);
    if (/[",\n]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
    return s;
  };
  const lines = [headers.join(","), ...rows.map((r) => headers.map((h) => escape(r[h])).join(","))];
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
